module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "l"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[0]),
      expression: "secondGuess[0]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 0, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("AlPO"), _c('sub', [_vm._v("4")]), _vm._v(" "), _c('sub', [_vm._v("(aq)")]), _vm._v(" +\n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[1]),
      expression: "secondGuess[1]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 1, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("Mg "), _c('sub', [_vm._v("(s)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("Al="), _c('span', [_vm._v(_vm._s(_vm.bottom0))])]), _vm._v(" "), _c('span', [_vm._v("P="), _c('span', [_vm._v(_vm._s(_vm.bottom1))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom2))])]), _vm._v(" "), _c('span', [_vm._v("Mg="), _c('span', [_vm._v(_vm._s(_vm.bottom3))])])])]), _vm._v(" "), _c('div', {
    staticClass: "a"
  }, [_vm._v("\n      ⟶ \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "r"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[2]),
      expression: "secondGuess[2]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 2, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("Al "), _c('sub', [_vm._v("(s)")]), _vm._v(" + \n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[3]),
      expression: "secondGuess[3]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 3, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("Mg"), _c('sub', [_vm._v("3")]), _vm._v("(PO"), _c('sub', [_vm._v("4")]), _vm._v(")"), _c('sub', [_vm._v("2")]), _vm._v(" "), _c('sub', [_vm._v("(aq)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("Al="), _c('span', [_vm._v(_vm._s(_vm.bottom4))])]), _vm._v(" "), _c('span', [_vm._v("P="), _c('span', [_vm._v(_vm._s(_vm.bottom5))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom6))])]), _vm._v(" "), _c('span', [_vm._v("Mg="), _c('span', [_vm._v(_vm._s(_vm.bottom7))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f3bda1b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Equation5.vue
// module id = 77
// module chunks = 1